var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCycling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3.5C13 1.567 14.567 0 16.5 0C18.433 0 20 1.567 20 3.5C20 5.43298 18.433 7 16.5 7C14.567 7 13 5.43298 13 3.5ZM16.5 2C15.6716 2 15 2.67158 15 3.5C15 4.32841 15.6716 5 16.5 5C17.3284 5 18 4.32841 18 3.5C18 2.67158 17.3284 2 16.5 2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5109 6.6077L13.5127 6.60965L16.1785 9.49514C16.1785 9.49514 16.1816 9.49787 16.1845 9.49916L16.1865 9.4999H20.0001C20.5524 9.4999 21.0001 9.94761 21.0001 10.4999C21.0001 11.0522 20.5524 11.4999 20.0001 11.4999H16.1851C15.6219 11.4999 15.0876 11.2603 14.7117 10.8547L12.0375 7.96016C12.0352 7.95767 12.0309 7.95859 12.0309 7.95859L9.00444 9.81915L12.036 11.6763L12.0372 11.677C12.6265 12.0372 12.9947 12.6835 12.9951 13.3838L13.0001 17.9988C13.0007 18.5511 12.5535 18.9993 12.0012 18.9999C11.4489 19.0005 11.0007 18.5533 11.0001 18.001L10.9951 13.386L10.9945 13.3846L10.9935 13.3831L7.25874 11.0952C6.31221 10.5092 6.31222 9.13058 7.25875 8.54464L7.26138 8.543L10.9895 6.2511C11.8071 5.75254 12.8631 5.90196 13.5109 6.6077Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.25 14.5C16.7312 14.5 15.5 15.7312 15.5 17.25C15.5 18.7688 16.7312 20 18.25 20C19.7688 20 21 18.7688 21 17.25C21 15.7312 19.7688 14.5 18.25 14.5ZM13.5 17.25C13.5 14.6266 15.6266 12.5 18.25 12.5C20.8734 12.5 23 14.6266 23 17.25C23 19.8734 20.8734 22 18.25 22C15.6266 22 13.5 19.8734 13.5 17.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 14.5C4.23122 14.5 3 15.7312 3 17.25C3 18.7688 4.23122 20 5.75 20C7.26878 20 8.5 18.7688 8.5 17.25C8.5 15.7312 7.26878 14.5 5.75 14.5ZM1 17.25C1 14.6266 3.12665 12.5 5.75 12.5C8.37335 12.5 10.5 14.6266 10.5 17.25C10.5 19.8734 8.37335 22 5.75 22C3.12665 22 1 19.8734 1 17.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCycling);
export default __webpack_public_path__ + "static/media/cycling.5f1f34444ac6743e5fae3dc77705a20e.svg";
export { ForwardRef as ReactComponent };